import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect } from "react";

export const ImageEditModal = (props) => {

    const [caption, setCaption] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [mainImage, setMainImage] = useState(false);

    useEffect(() => {
        if (props.imageInfo) {
            setCaption(props.imageInfo.caption);
            setTitle(props.imageInfo.title);
            setDescription(props.imageInfo.description);
            setMainImage(props.imageInfo.isPrimaryImage);
        }
    }, [props])

    return props.show && props.imageInfo ?
        (
            <Modal
                show={props.show}
                onHide={props.handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Image Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-12">
                        <label className="form-label col-form-label col-md-2">Caption</label>
                        <div className="col-md-10">
                            <input type="text" className="form-control" placeholder="Enter Caption" value={caption} onChange={e => {
                                setCaption(e.target.value);
                            }} />
                        </div>
                    </div>
                    <div className="row mb-12">
                        <label className="form-label col-form-label col-md-2">Title</label>
                        <div className="col-md-10">
                            <input type="text" className="form-control" placeholder="Enter Title" value={title} onChange={e => {
                                setTitle(e.target.value);
                            }} />
                        </div>
                    </div>
                    <div className="row mb-12">
                        <label htmlFor="descriptionId" className="form-label col-form-label col-md-2">Description</label>
                        <div className="col-md-10">
                            <textarea style={{ minHeight: '100px' }} className="form-control" rows="3" id="descriptionId" placeholder='New Description' value={description} onInput={e => setDescription(e.target.value)} />
                        </div>
                    </div>

                    <div className="row mb-12">
                        <label className="form-label col-form-label col-md-3">Main Image</label>
                        <div className="col-md-9 pt-2">
                            <div className="form-check form-switch">
                                <label className="form-check-label" htmlFor="mainImage"></label>
                                <input className="form-check-input" type="checkbox" id="mainImage" checked={mainImage} onChange={e => setMainImage(e.target.checked)} />
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className='row mb-12'>
                    <div className='btn-group justify-content-end'>
                        <div className='col-md2 me-5px'>
                            <Button variant="secondary" onClick={() => { props.handleCancel(); }}>
                                Cancel
                            </Button>
                        </div>
                        <div className='col-md2 me-5px'>
                            <Button variant="primary" onClick={() => { props.handleSave({ image: props.imageInfo, newDetails: { caption, title, description, isPrimaryImage: mainImage } }); }}>
                                <i className="fa fa-save fa-lg me-2 ms-n2 text-success-900"></i>
                                Save
                            </Button>
                        </div>
                        <div className='col-md2'>
                            <Button variant="secondary" onClick={() => { props.handleDeleteImage({ image: props.imageInfo }); }}>
                                <i className="fa fa-trash fa-lg me-2 ms-n2 text-success-900"></i>
                                Delete
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal >
        ) :
        (<></>);
};